// tslint:disable:max-line-length

import classNames from "classnames";
import React from "react";
import { connect } from "react-redux";
import tinycolor from "tinycolor2";

import * as WebRoutes from "@travellocal/utils/webRoutes";
import { AbtaLogo, AtolLogo, LineDots, Loader, StarRating } from "../../../../core/atoms";
import { RoutesInvoker } from "../../../routesInvoker";

import "./submitEnquiryForm.scss";

interface OwnProps {
  setSubmitButtonRef: (x) => void;
  setSubmitErrorWrapRef: (x) => void;
  errorMessages: string[];
  headerImageColour: string;
  isSubmitting: boolean;
  showEmailReset: boolean;
}

interface StateProps {
  rrfState: Forms.WebFormRoot;
}

type Props = OwnProps & StateProps;

const stateToProps = (state: IWebStoreState, ownProps: OwnProps): StateProps => {
  return {
    rrfState: state.forms,
  };
};

class SubmitEnquiryForm extends React.Component<Props> {
  public constructor(props: Props) {
    super(props);
  }

  public render() {
    const {
      setSubmitButtonRef,
      setSubmitErrorWrapRef,
      errorMessages,
      headerImageColour,
      rrfState,
      isSubmitting,
      showEmailReset,
    } = this.props;
    const formState = rrfState.enquiry;
    const hasCountry = formState.location != null;
    const formHasErrors = errorMessages && errorMessages.length > 0;

    let headerImageColourDarkened: string;
    if (headerImageColour) {
      headerImageColourDarkened = tinycolor(headerImageColour).darken(25).toString();
    }

    let ltoImageUrl: string;
    if (hasCountry && formState.location.images) {
      const ltoImage: ILocationImage = formState.location.images.find(img => img.locationImageType === LocationImageType.LtoMain);

      if (ltoImage) {
        ltoImageUrl = ltoImage.thumbnailUrl;
      }
    }

    // Set outline colour so that it is visible against the background country colour
    const outlineColour = tinycolor.mostReadable(headerImageColour, ["000", "FFF"]).toHexString();
    const rootStyle: React.CSSProperties = {};
    rootStyle["--page-outline"] = outlineColour;
    rootStyle.color = headerImageColour;

    return (
      <div className="submit-form-wrap">
        <div className="submit-form-wrap__trust">
          <div className="submit-form-wrap__trust--signals">
            <div className="submit-form-wrap__trust--affiliates">
              <h4 className="text--caps">Book with confidence</h4>
              <div className="submit-form-wrap__trust--logos">
                <AtolLogo type="dark" width={70} />
                <AbtaLogo type="dark" width={140} />
              </div>
            </div>
            <div className="submit-form-wrap__trust--recommendation">
              <h4 className="text--caps">96% of customers would recommend us to a friend</h4>
              <StarRating maximumValue={5} currentValue={5} aria-hidden={true} />
            </div>
            <div className="submit-form-wrap__trust--dots">
              <LineDots
                height="300"
                x1="1%"
                y1="6px"
                x2="1%"
                y2="100%"
                colour={headerImageColour}
              />
            </div>
          </div>
          <div
            className={classNames("submit-form-wrap__trust--lto", {
              "has-image": ltoImageUrl ? true : false,
              "has-errors": formHasErrors ? true : false,
            })}
          >
            <img
              className="lazyload avatar avatar-rounded"
              data-src={ltoImageUrl}
              alt="Your local experts"
              height={120}
              width={120}
            />
          </div>
        </div>
        {formHasErrors && (
          <div className="submit-form-wrap__errors">
            <div className="submit-form-wrap__errors--content heading--4" style={{
              backgroundColor: headerImageColourDarkened,
            }}>
              <ul ref={x => setSubmitErrorWrapRef(x)} className="rrf-errors">
                <li><i className="icon icon-warning2" /></li>
                {errorMessages.map((message, i) => <li key={i}>{message}</li>)}
                {showEmailReset &&
                  <li className="reset-pw">
                    <a href={`${globalConfig.wwwBaseUrl}${RoutesInvoker.forgottenPassword()}`} target="_blank">Click here if you don't know your password</a>
                  </li>
                }
              </ul>
            </div>
          </div>
        )}
        <div className="submit-form" style={{ backgroundColor: headerImageColour }}>
          {isSubmitting &&
            <div className="submit-form__loading">
              <Loader />
            </div>
          }
          {!isSubmitting &&
            <div className="submit-wrap">
              <button
                ref={x => setSubmitButtonRef(x)}
                type="submit"
                className="primary-button enquiry-form-button"
                style={rootStyle}
              >
                Send your enquiry
              </button>
            </div>
          }
          <p className="legal">
            <small>
              By submitting an enquiry, you agree to abide by TravelLocal's <a href={`${globalConfig.wwwBaseUrl}${WebRoutes.termsOfUse()}`} target="_blank">Terms of Use</a> and <a href={`${globalConfig.wwwBaseUrl}${WebRoutes.termsAndConditions()}`} target="_blank">Terms and Conditions</a>, and acknowledge that your data will be processed in accordance with our <a href={`${globalConfig.wwwBaseUrl}${WebRoutes.privacy()}`} target="_blank">Privacy Policy</a>. We securely store your information, and will only share it with our partners for the purposes of servicing your enquiry.
            </small>
          </p>
        </div>
      </div>
    );
  }
}

export default connect(stateToProps)(SubmitEnquiryForm);
